/**
 * @generated SignedSource<<6966565f509e2bc2e9f0a951a4d4f300>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "shareVibePost",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "VibePost",
        "kind": "LinkedField",
        "name": "sharedPost",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharesCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sharedByCurrentUser",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "postItemFeaturesMenuShareVibePostMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "postItemFeaturesMenuShareVibePostMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "457de3d8cd5083e29d28543933aa6395",
    "id": null,
    "metadata": {},
    "name": "postItemFeaturesMenuShareVibePostMutation",
    "operationKind": "mutation",
    "text": "mutation postItemFeaturesMenuShareVibePostMutation(\n  $request: ShareVibePostRequestInput!\n) {\n  shareVibePost(request: $request) {\n    id\n    sharedPost {\n      id\n      sharesCount\n      sharedByCurrentUser\n    }\n  }\n}\n"
  }
};
})();

node.hash = "6fee140ace5f6930f2625581dd067e19";

module.exports = node;
